export function getRefetchTransactionQueries() {
	return [
		'Transactions',
		'NeedsApprovalTransactions',
	]
}
